'use client';

export const APPLY_V3_STEPS = {
  bundleUpsell: {
    name: 'bundle-selection',
    number: '2',
  },
  capture: {
    name: 'lead-submission',
    number: '1',
  },
} as const;
